export const messages = {
  en: {
    propertyCompanyManage: {
      queryCondition: 'Query Conditions',
      propertyCompany: 'Property Company',
      search: 'Search',
      reset: 'Reset',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      login: 'Login',
      restrictLogin: 'Restrict Login',
      restoreLogin: 'Restore Login',
      resetPwd: 'Reset Password',
      manageCommunity: 'Manage Community',
      enterStoreId: 'Please enter store ID',
      enterName: 'Please enter name',
      enterTel: 'Please enter telephone',
      storeId: 'Store ID',
      name: 'Name',
      address: 'Address',
      tel: 'Telephone',
      corporation: 'Corporation',
      foundingTime: 'Founding Time',
      landmark: 'Landmark',
      createTime: 'Create Time',
      operation: 'Operation',
      tip: 'Tip: Default admin account is mobile number, password is mobile number',
      fetchError: 'Failed to fetch property company list',
      fetchStaffError: 'Failed to fetch staff information',
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm to delete property company',
      confirmUpdateState: 'Confirm to',
      confirmResetPwd: 'Confirm to reset password',
      passwordConfirm: 'Password Confirmation',
      password: 'Password',
      enterCurrentPassword: 'Please enter current account password',
      passwordRequired: 'Password is required',
      selectCommunities: 'Please select communities',
      functions: 'Functions',
      all: 'All',
      communities: 'Communities',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      deleteSuccess: 'Delete successfully',
      updateSuccess: 'Update successfully',
      resetPwdSuccess: 'Reset password successfully, new password is {pwd}, please change it in time',
      fetchMenuError: 'Failed to fetch menu groups',
      fetchCommunityError: 'Failed to fetch communities',
      selectAccount: 'Select Account',
      belongTo: 'Belong To',
      role: 'Role',
      selectUserFirst: 'Please select a user first',
      noCommunityAssigned: 'No community assigned'
    }
  },
  zh: {
    propertyCompanyManage: {
      queryCondition: '查询条件',
      propertyCompany: '物业公司',
      search: '查询',
      reset: '重置',
      add: '添加',
      edit: '修改',
      delete: '删除',
      login: '登录',
      restrictLogin: '限制登录',
      restoreLogin: '恢复登录',
      resetPwd: '重置密码',
      manageCommunity: '管理园区',
      enterStoreId: '请输入物业编号',
      enterName: '请输入名称',
      enterTel: '请输入电话',
      storeId: '编号',
      name: '名称',
      address: '地址',
      tel: '电话',
      corporation: '公司法人',
      foundingTime: '成立日期',
      landmark: '地标',
      createTime: '创建时间',
      operation: '操作',
      tip: '温馨提示：默认管理员账号为手机号；密码为手机号',
      fetchError: '获取物业公司列表失败',
      fetchStaffError: '获取员工信息失败',
      confirmOperation: '请确认您的操作',
      confirmDelete: '确定删除物业公司',
      confirmUpdateState: '确认是否',
      confirmResetPwd: '确认是否重置密码',
      passwordConfirm: '密码确认',
      password: '密码',
      enterCurrentPassword: '必填，请输入当前账号密码',
      passwordRequired: '密码不能为空',
      selectCommunities: '请选择开通园区',
      functions: '功能',
      all: '全部',
      communities: '园区',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功',
      updateSuccess: '更新成功',
      resetPwdSuccess: '修改密码成功，密码为{pwd}请及时修改密码',
      fetchMenuError: '获取菜单组失败',
      fetchCommunityError: '获取园区信息失败',
      selectAccount: '选择账号',
      belongTo: '所属',
      role: '角色',
      selectUserFirst: '请先选择用户',
      noCommunityAssigned: '未分配园区'
    },
  }
}